var map = {
	"./drdoctor/img/icons/new_medical_info_icon.png": 619,
	"./freedoctor/img/icons/new_medical_info_icon.png": 620,
	"./freelegal/img/icons/new_medical_info_icon.png": 621,
	"./legalchief/img/icons/new_medical_info_icon.png": 622,
	"./medi4u/img/icons/new_medical_info_icon.png": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 618;